export interface NotificationBaseViewModel {
    id: string; // Guid maps to string in TypeScript
    description: string;
    created: Date;
    notificationType?: NotificationType; // Nullable becomes optional (?)
    isRead: boolean;
}

export interface NotificationViewModel {
    id: string;
    taskId?: string;
    description: string;
    title?: string;
    deadLine?: Date;
    contentUrl?: string;
    content?: string;
    created: Date;
    notificationType?: NotificationType;
    isRead: boolean;
    processingActivityTaskViewModel: Array<ProcessingActivityValidationTaskViewModel>;
    notificationPeriodInDays: number;
    processingActivityName?: string;
    processingActivityId?: string;
    sender?: string;
    fromUser: string | undefined;
    annualWheelActivityId?: string;
    isProcessingActivityValidation: boolean;
}

export interface ProcessingActivityValidationTaskViewModel {
    processingActivityId: string;
    processingActivityName: string;
}

export enum NotificationType {
    Task = 1,
    Release = 3,
    LegalUpdates = 4,
    ProcessingActivityCommentType = 5,
    TaskComment = 7,
    TaskAssignee = 8,
    TaskResponsible = 9,
    TaskCompleted = 10,
    TaskReadyForApproval = 11,
    RiskObservationConverted = 12,
    TaskReminder = 13,
}

export const getNotificationHeader = (notificationType: NotificationType | undefined, translateString: (key: string, interpolation?: any) => string) => {
    switch (notificationType) {
        case NotificationType.LegalUpdates:
            return translateString("legalUpdatesNotification");
        case NotificationType.Release:
            return translateString("newFunctionsHeader");
        case NotificationType.ProcessingActivityCommentType:
            return translateString("notificationNewCommentNotification");
        case NotificationType.TaskComment:
            return translateString("notificationNewCommentNotification");
        case NotificationType.TaskCompleted:
            return translateString("taskCompleted");
        case NotificationType.TaskReadyForApproval:
            return translateString("taskReadyForApproval");
        case NotificationType.RiskObservationConverted:
            return translateString("riskObservationConvertedNotificationHeader");
        case NotificationType.TaskReminder:
            return translateString("taskReminderNotificationHeader");
        default:
            return translateString("taskNotification");
    }
};

export function getNotificationDescriptionCompact(notification: NotificationBaseViewModel, translateString: any) {
    switch (notification.notificationType) {
        case NotificationType.ProcessingActivityCommentType:
            return translateString("notificationNewCommentFullNotificationHeader");
        case NotificationType.TaskComment:
            return translateString("notificationNewCommentFullNotificationHeader");
        case NotificationType.TaskAssignee:
            return translateString("assigneeNotificationLimitedDescription");
        case NotificationType.TaskResponsible:
            return translateString("taskResponsibleNotificationLimitedDescription");
        case NotificationType.TaskReminder:
            return translateString("taskReminderNotificationLimitedDescription");
        default:
            return notification.description;
    }
}

export function getNotificationDescriptionExpanded(notification: NotificationViewModel, translateString: any) {
    switch (notification.notificationType) {
        case NotificationType.ProcessingActivityCommentType:
            return translateString("notificationNewCommentNotificationDescription", { name: notification.processingActivityName });
        case NotificationType.TaskComment:
            return translateString("notificationNewTaskCommentNotificationDescription", { name: notification.description });
        case NotificationType.TaskAssignee:
            return translateString("assigneeNotificationNormalDescription", { name: notification.description });
        case NotificationType.TaskResponsible:
            return translateString("taskResponsibleNotificationNormalDescription", { name: notification.description });
        case NotificationType.TaskReminder:
            return translateString("taskReminderNotificationNormalDescription", { name: notification.description });
        case NotificationType.RiskObservationConverted:
            return translateString("riskObservationConvertedNotificationDescription");
        default:
            return notification.description;
    }
}
